import EmailAddress from "_shared/email-addresses/email-address";
import Name from "_shared/names/name";

export default class AcceptOpenEntityMemberInvitationAPIRequest {
  public readonly email: string;
  public readonly firstName: string;
  public readonly lastName: string;

  public constructor(email: EmailAddress, name: Name) {
    this.email = email.value;
    this.firstName = name.firstName;
    this.lastName = name.lastName;
  }
}
